import { JobApplicationStatus } from './job-application-status.model';
import { Job } from '../../job/models/job.model';

export class JobApplication {
  constructor(
    public candidateId: string = '',
    public closed: boolean = false,
    public createdBy: string = '',
    public createdDate: string = '',
    public currency: string = '',
    public deleted: boolean = false,
    public email: string = '',
    public emailNotifiable: boolean = true,
    public expectedSalary: number = 0,
    public file: JobApplicationFile = new JobApplicationFile(),
    public firstname: string = '',
    public fullname: string = '',
    public id: string = '',
    public job: Job = new Job(),
    public jobApplicationStatuses: JobApplicationStatus[] = [],
    public lastname: string = '',
    public ownerFullname: string = '',
    public phoneNumber: string = '',
    public relevance: number = 0,
    public visible: boolean = true,
    public skills: any[] = [],
    public websiteURL: string = '',
    public whatsappNotifiable: boolean = false,
    public candidate: any = '',
    public client: string = '',
    public appliedOn: string = '',
    public status: string = '',
    public jobName: string = '',
    public recruiter: string = '',
    public rate: number | null = null
  ) {}
}

export class JobApplicationFile {
  constructor(
    public contentType: string = '',
    public createdBy: string = '',
    public createdDate: string = '',
    public fileType: string = '',
    public id: string = '',
    public name: string = '',
    public firstname: string = '',
    public fullname: string = ''
  ) {}
}
